import React from 'react';
import styles from './style.module.scss';
import PageRect from './singlePage';
import Layout from 'components/layout';
import { Skeleton } from 'antd';
import { useRecoilValue } from 'recoil';
import { getPages, getUserLoadingState } from 'hooks/useUser';

const HomePage = () => {
  const pages = useRecoilValue(getPages);
  const loading = useRecoilValue(getUserLoadingState);
  // console.log('pages', pages);
  return (
    <Layout hideSideBar>
      <div className={styles.homePageContainer}>
        {loading && <Skeleton paragraph={{ rows: 16 }} active />}
        {!loading && (
          <div className={styles.homePageContainer_content}>
            <div className={styles.title}>Benvenuto!</div>
            <div className={styles.homePageContainer_pages}>
              {pages.map((i, index) => (
                <PageRect key={index} data={i} />
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default HomePage;
